;(function( $ ) {
    'use strict';
    $( document ).ready( function() {
        $( '.entry-content, .article-body' ).fitVids(
            {
                customSelector: [
                    "iframe[src^='http://www.facebook.com/plugins/video.php']",
                    "iframe[src^='http://www.brightcove.com']",
                    "iframe[src^='http://bcove.me']",
                    "iframe[src^='http://link.brightcove.com']",
                    "iframe[src^='http://blip.tv']",
                    "iframe[src^='http://d.yimg.com']",
                    "iframe[src^='http://www.dailymotion.com']",

                    "iframe[src^='https://www.facebook.com/plugins/video.php']",
                    "iframe[src^='https://www.brightcove.com']",
                    "iframe[src^='https://bcove.me']",
                    "iframe[src^='https://link.brightcove.com']",
                    "iframe[src^='https://blip.tv']",
                    "iframe[src^='https://d.yimg.com']",
                    "iframe[src^='https://www.dailymotion.com']"
                ].join( ',' )
            } );

        $( '.faq-list' ).each( function() {
            var $this = $( this );

            $this.children( 'li' ).click( function() {
                // Add a class to the root item to tell us we're using JS now so we can stop with the CSS hacks
                $this.addClass( 'running' );

                $( this )
                    .addClass( 'active' )
                    .siblings()
                    .removeClass( 'active' );
            } );
        } );

        var evnt, $body = $( 'body' );
        $( 'input[name="menu-toggle"]' ).on( 'change', function() {

            clearTimeout( evnt );

            // If the currently active menu input has a value of "full" we should tell everyone.
            if ( $( this ).val() === 'full' ) {
                // We need to wait a moment before adding the overlay class
                evnt = setTimeout( function() {
                    $body.addClass( 'overlayed' );
                }, 250 );
            }
            else {
                // Remove it immediately
                $body.removeClass( 'overlayed' );
            }
        } );


        var rsz, $sub = $( '#sub-menu-off' ), $window = $( window ), w = $window.width();
        /* If the screen is re-sized we need to turn the menu off */
        $window.on( 'resize', window, function() {
            clearTimeout( rsz );
            rsz = setTimeout( function() {
                var newW = $window.width();
                // But only if the width passes the breakpoint
                if ( (w < 768 && newW >= 768) || (w >= 768 && newW < 768) ) {
                    w = newW;
                    $sub.prop( 'checked', true ).trigger( 'change' );
                }
            }, 200 );
        } );

        // Move the align class from the image down to the anchor wrapping the image
        $( '.article-body a[rel^="attachment"], .article-body a[rel*=" attachment"]' )
            .each( function() {
                var $this = $( this ),
                    $child = $this.children( 'img.alignleft, img.alignright' );

                if ( $child.length ) {
                    if ( $child.hasClass( 'alignleft' ) ) {
                        $this.addClass( 'alignleft' );
                        $child.removeClass( 'alignleft' );
                    }
                    else {
                        $this.addClass( 'alignright' );
                        $child.removeClass( 'alignright' );
                    }
                }
            } );

        var taggedHistory = (function() {
                // Tag the place we come in on so we know when we get back here.
                if ( typeof (window.history.replaceState) === 'function' ) {
                    window.history.replaceState( { page: 1, href: location.href }, document.title );
                    return true;
                }

                return false;
            }()),
            closeOverlay = function( e ) {
                // Send the focus back to the menu item that got us here.
                $( document ).find( 'a[href="' + window.location.hash + '"]' ).first().focus();

                // Check if we're trying to close on the first page in the history
                if ( !taggedHistory || window.history.state && window.history.state.page === 1 ) {
                    window.location.hash = '';
                }
                // Most of the time we'll just be using the history object to go back.
                else {
                    window.history.go( -1 );
                }
            };

        // Clicking the overlay close
        $( document ).on( 'click', '.ol-close.iconned', function( e ) {
            closeOverlay();
            e.preventDefault( e );
        } );

        // Close the overlays using the ESC key
        $( document ).keyup( function( e ) {
            if ( e.keyCode === 27 && (window.location.hash === '#navigation' || window.location.hash === '#login' || window.location.hash === '#search') ) {
                closeOverlay();
            }
        } );

//		$( 'header.site-head' ).flagOffScreen( { offsetTop: 140, top: false } );

        // Wrap report tables
        $( '.report-content table' ).wrap( "<div class='table-wrapper'></div>" );

        /* Remove the video poster to stop the "flash" image */
        // var $window = $( window ),
        //     oldW    = $window.width();
        //
        // $( '.featured-video' ).each( function() {
        //     var evnt,
        //         $this         = $( this ),
        //         toggle_poster = function() {
        //             var newW = $window.width();
        //             // But only if the width passes the breakpoint
        //             if ( oldW < 900 && newW >= 900 || oldW >= 900 && newW >= 900 ) {
        //                 oldW = newW;
        //                 $this.prop( 'poster', '' );
        //             }
        //             else if ( oldW >= 900 && newW < 900 ) {
        //             	oldW = newW;
        //                 $this.prop( 'poster', $this.data( 'poster' ) );
        //             }
        //         };
        //
        //     // Copy the poster over to a data attribute so we can copy it back again later
        //     $this.data( 'poster', $this.prop( 'poster' ) );
        //     toggle_poster();
        //
        //     // If the screen is re-sized check that poster is needed or not
        //     $window.on( 'resize', window, function() {
        //         clearTimeout( evnt );
        //         evnt = setTimeout( toggle_poster, 200 );
        //     } );
        // } );

//		var $header = $( 'header.site-head' );
//		$header.flagOffScreen(
//			{
//				offsetTop: function() {
//					return parseInt( $header.outerHeight( true ), 10 );
//				},
//				top: false
//			} );

        // Any GET params passed with these names will be sent, on click, to any link matching the hostname pattern.
//		$( 'a' ).campaingTracking(
//			{
//				get: [ 'sourcecode', 'campaigncode' ],
//				host: 'ad.marketingweek.com|marketingweek\.[^\.]*\.sgizmo.com',
//				time: 3600,
//				overwrite: true
//			}
//		);

        // Auto adjust iFrame according to content
//        $('iframe').iFrameResize([{
//            log: false,
//            autoResize: false,
//            heightCalculationMethod: 'bodyScroll',
//            scrolling: true
//        }]);
    } );
}( jQuery ));
